<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alert-dismissable slide_animation_forwards" (click)="removeAlert(alert, $event, false)">
  {{alert.message}}
  <a class="close" (click)="removeAlert(alert, $event, true)">&times;</a>
</div>
